<script>
import navegacion from './elements/Navegacion.vue'
import ingredientesQuicktable from '../Concepts/Ingredientes/quicktable.vue'
export default {
    name: 'CatalogosIngredientes',
    components: { navegacion, ingredientesQuicktable },
    methods: {
        catLoaded() {
            if (!!this.$refs && !!this.$refs.nutricionales) {
                this.$refs.nutricionales.refresh()
            }
        }
    }
}
</script>

<template>
    <div id="CatalogosIngredientes">
        <navegacion class="mb-4"/>
        <ingredientes-quicktable />
    </div>
</template>